<h2>Our Partners</h2>

<div class="logos-wrapper">
  <img src="/assets/img/partners/ten-tech-logo.svg" alt="Our Partner" height="57px">
  <img src="/assets/img/partners/jchs-logo.svg" alt="Our Partner" height="65px">
  <img src="/assets/img/partners/NSRDEC.svg" alt="Our Partner" height="49px">
  <img src="/assets/img/partners/usariem-logo.png" alt="Our Partner" height="57px">
</div>
